import axios from 'axios';
import {backendHost} from '../../config';

export const putLandings = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/landings`, params);
};